import type { ReactNode } from 'react';
import { Button, Flex, HeaderItalic, Text } from '@/components/common';

interface EmptyStateProps {
  icon?: ReactNode;
  title: string;
  description?: string;
  action?: { label: string; onClick: () => void };
}

export function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <Flex direction="column" align="center" gap="4" py="9" px="4">
      {icon}
      <Flex direction="column" align="center" gap="1">
        <HeaderItalic size="4" align="center">
          {title}
        </HeaderItalic>
        {description && (
          <Text size="2" color="gray" align="center">
            {description}
          </Text>
        )}
      </Flex>
      {action && <Button onClick={action.onClick}>{action.label}</Button>}
    </Flex>
  );
}

export type { EmptyStateProps };
